import { loadBasic } from "@tsparticles/basic";
import { loadDestroyUpdater } from "@tsparticles/updater-destroy";
import { loadEmittersPlugin } from "@tsparticles/plugin-emitters";
import { loadEmittersShapeSquare } from "@tsparticles/plugin-emitters-shape-square";
import { loadLifeUpdater } from "@tsparticles/updater-life";
import { loadLineShape } from "@tsparticles/shape-line";
import { loadRotateUpdater } from "@tsparticles/updater-rotate";
import { loadSoundsPlugin } from "@tsparticles/plugin-sounds";
import { loadStrokeColorUpdater } from "@tsparticles/updater-stroke-color";
import { options } from "./options.js";
export async function loadFireworksPreset(engine, refresh = true) {
    await loadBasic(engine, false);
    await loadEmittersPlugin(engine, false);
    await loadEmittersShapeSquare(engine, false);
    await loadSoundsPlugin(engine, false);
    await loadLineShape(engine, false);
    await loadRotateUpdater(engine, false);
    await loadDestroyUpdater(engine, false);
    await loadLifeUpdater(engine, false);
    await loadStrokeColorUpdater(engine, false);
    await engine.addPreset("fireworks", options, false);
    await engine.refresh(refresh);
}
